// Public invitation handoff is tab-scoped and deliberately independent of an
// authenticated portal generation. A fresh sign-in replaces that generation.
// This slot contains only a bounded bearer secret, never account/profile data.
export const DOCTOR_INVITATION_HANDOFF_KEY = "doctor-dashboard:doctor-invitation:handoff";
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

export function isDoctorInvitationHandoff(value: string | null): boolean {
  try {
    const record = JSON.parse(value || "null");
    return Boolean(record && Object.keys(record).length === 2 &&
      typeof record.token === "string" && /^[A-Za-z0-9_-]{40,128}$/.test(record.token) &&
      Number.isFinite(record.capturedAt) && record.capturedAt >= 0);
  } catch { return false; }
}

export function readDoctorInvitationToken(): string {
  const value = sessionStorage.getItem(DOCTOR_INVITATION_HANDOFF_KEY);
  if (!isDoctorInvitationHandoff(value)) return "";
  const record = JSON.parse(value!);
  if (record.capturedAt > Date.now() || Date.now() - record.capturedAt >= MAX_AGE_MS) {
    clearDoctorInvitationToken();
    return "";
  }
  return record.token;
}

export function clearDoctorInvitationToken() {
  sessionStorage.removeItem(DOCTOR_INVITATION_HANDOFF_KEY);
}

/** Runs before importing bootstrap, telemetry or third-party integrations. */
export function captureDoctorInvitationSecret() {
  const path = window.location.pathname.replace(/\/+$/, "");
  if (path !== "/dashboard/doctor-invitation") return;
  const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
  if (token) {
    history.replaceState(history.state, "", path + window.location.search);
    if (/^[A-Za-z0-9_-]{40,128}$/.test(token)) {
      sessionStorage.setItem(DOCTOR_INVITATION_HANDOFF_KEY, JSON.stringify({ token, capturedAt: Date.now() }));
    }
  }
  const referrer = document.createElement("meta");
  referrer.name = "referrer";
  referrer.content = "no-referrer";
  document.head.append(referrer);
}
